import React, { useEffect, useState } from "react";
import { Button, Container, Modal, ModalHeader } from "semantic-ui-react";
import { updateClient } from "services/custom-features";
import ClientCreate from "./ClientCreate";

// Define defaultWebhookMap as a string for reuse
const defaultWebhookMap = JSON.stringify({
  defaultUrl: {
    "url": "",
    "method": "POST"
  },
  updateFieldTask: {},
  updateWorklog: {},
  bulkUploadTask: {},
  startTravelTime: {},
  stopTravelTime: {},
  cancelTravelTime: {},
  onsiteTravelTime: {},
  releaseTravelTime: {},
  updateFacilityRequest: {},
  takeFieldTask: {},
  takefieldtaskandtravel: {},
  createFieldTask: {}
}, null, 2);

function ClientEditPopup(props) {
  const { handler, open, totalEnvOptions, setNotification, client, clientEnv} = props;

  const [errors, setErrors] = useState({});

  const updateClientOnboarding = async () => {
    let {
      clientName,
      clientEmail,
      env,
      webhookAuthType,
      webhookAuthId,
      webhookAuthSecret,
      webhookContentType,
      webhookGrantType,
      webhookScope,
      webhookTokenUrl,
      clientId,
      webhooksMap
    } = formData;

    const newErrors = {};

    if (!clientName) {
      newErrors.clientName = "Client name is required**";
    }

    if (!clientEmail) {
      newErrors.clientEmail = "Client email is required**";
    }

    if (!env) newErrors.env = "Environment is required";

    if (webhookAuthType) {
      if (!webhookAuthId)
        newErrors.webhookAuthId = "Webhook Username is required**";
      // if (!webhookAuthSecret)
      //   newErrors.webhookAuthSecret = "Webhook Password is required**";
      if (webhookAuthType === "OAUTH2" && !webhookTokenUrl)
        newErrors.webhookTokenUrl = "Webhook Token URL is required**";
    }

    if (!webhookAuthType) {
      webhookAuthId = "";
      webhookAuthSecret = "";
      webhookContentType = "";
      webhookGrantType = "";
      webhookTokenUrl = "";
      webhookScope = "";
    }
    if (Object.keys(newErrors).length === 0) {
      const updatePayload = {
        clientName,
        clientEmail,
        env,
        webhookAuthType,
        webhookAuthId,
        webhookContentType,
        webhookGrantType,
        webhookScope,
        webhookTokenUrl,
        clientId,
        webhooksMap,
        ...(webhookAuthSecret && { webhookAuthSecret }),
      };

      const response = await updateClient(updatePayload);

      setNotification({
        status: response.status,
        showMessage: true,
        message: response.message,
      });
      handler(false);

      setFormData({
        clientName: "",
        clientEmail: "",
        env: "",
        webhookAuthType: "",
        webhookAuthId: "",
        webhookAuthSecret: "",
        webhookContentType: "",
        webhookGrantType: "",
        webhookScope: "",
        webhookTokenUrl: "",
        webhooksMap: {
          defaultUrl: {
            url: "https://example.com",
            method: "POST",
          },
        },
      });
      setErrors({});
    } else {
      // Display validation errors
      setErrors(newErrors);
    }
  };

  const [formData, setFormData] = useState({
    clientName: "",
    clientEmail: "",
    env: "",
    webhookAuthType: "",
    webhookAuthId: "",
    webhookAuthSecret: "",
    webhookContentType: "",
    webhookGrantType: "",
    webhookScope: "",
    webhookTokenUrl: "",
    clientId: "",
    webhooksMap: defaultWebhookMap,
  });

  useEffect(() => {
    if (open && client) {
      setFormData({
        clientName: client.client_name,
        clientEmail: client.client_email,
        env: clientEnv,
        webhookAuthType: client.webhook_auth_type,
        webhookAuthId: client.webhook_auth_id,
        webhookAuthSecret: "",
        webhookContentType: client.webhook_content_type,
        webhookGrantType: client.webhook_grant_type,
        webhookScope: client.webhook_scope,
        webhookTokenUrl: client.webhook_token_url,
        clientId: client.client_id,
        webhooksMap: client.webhooks_map ? client.webhooks_map : defaultWebhookMap,
      });
    }
  }, [open, client, clientEnv]);

  return (
    <Modal
      onClose={() => handler(false)}
      onOpen={() => handler(true)}
      open={open}
    >
      <ModalHeader>
        Edit Client
        <Button
          onClick={() => handler(false)}
          style={{ float: "right" }}
          content="X"
        />
      </ModalHeader>
      <Container fluid style={{ padding: "2em" }}>
        <ClientCreate
          formData={formData}
          setFormData={setFormData}
          totalEnvOptions={totalEnvOptions}
          errors={errors}
          createClientOnboarding={updateClientOnboarding}
          isEdit={true}
        />
      </Container>
    </Modal>
  );
}

export default ClientEditPopup;
